<template>
<div>
    <div class="text-content-section">
        <loading :active.sync="isLoading" 
        :can-cancel="false" 
        :is-full-page="true"></loading>
        <h2>Manage Users</h2>
        <div v-if="serverErrors.length > 0" class="alert alert-danger" role="alert">
            <ul>
                <li v-for="(item, index) in serverErrors" :key="index">{{item}}</li>
            </ul>
        </div>
        <ul class="nav nav-tabs vesta-tabs" role="tablist">
            <li class="nav-item">
                <a class="nav-link admin-nav-link active"  href="#pendingUsers" role="tab" data-toggle="tab">Pending Users</a>
            </li>
            <li class="nav-item">
                <a class="nav-link admin-nav-link" href="#activeUsers" role="tab" data-toggle="tab">Active Users</a>
            </li>
        </ul>
        <div class="tab-content">
            <div role="tabpanel" class="tab-pane fade in active show" id="pendingUsers">
                <div class="card">
                    <div class="card-body">
                        <h4>Pending Users <small class="badge badge-primary badge-pill">{{this.pendingTotalItems}}</small></h4>
                        <table class="table">
                            <thead>
                                <tr>
                                    <th scope="col">First Name</th>
                                    <th scope="col">Last Name</th>
                                    <th scope="col">Email</th>
                                    <th scope="col">Spouse Name</th>
                                    <th scope="col"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item) in pendingUsers" v-bind:key="item.Id">
                                    <td>{{item.FirstName}}</td>
                                    <td>{{item.LastName}}</td>
                                    <td>{{item.Email}}</td>
                                    <td>{{item.SpouseName}}</td>
                                    <td>
                                        <button type="button" class="btn btn-sm vesta-gray-btn" style="margin-right: 1em;" @click="setPendingUserActive(item.Id)">Set Active</button>
                                        <button type="button" class="btn btn-sm vesta-gray-btn" data-toggle="modal" data-target="#deleteUserModal" @click="setDeleteUserId(item.Id);">Delete</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                         <pagination
                            v-bind:total-pages="pendingTotalPages"
                            v-bind:total="pendingTotalItems"
                            :per-page="10"
                            v-bind:current-page="pendingCurrentPage"
                            @pagechanged="onPendingPageChange"
                            />
                    </div>
                </div>
            </div>
            <div role="tabpanel" class="tab-pane fade" id="activeUsers">
                <div class="card">
                    <div class="card-body">
                        <div class="card">
                            <div class="card-body">
                                <div class="d-flex justify-content-between" style="padding: 5pt">
                                    <h4>Active Users <small class="badge badge-primary badge-pill">{{this.activeTotalItems}}</small></h4>
                                    <form class="form-inline" @submit.prevent>
                                        <input class="form-control" type="search" name="q" placeholder="Search" aria-label="Search" v-on:keyup.enter="searchUser" v-model="searchText">
                                        <button type="button" class="btn btn-sm vesta-gray-btn" @click="cancelSearch">Cancel</button>
                                    </form>

                                </div>
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th scope="col">Contact</th>
                                            <th scope="col">Role</th>
                                            <th scope="col">Comment</th>
                                            <th scope="col"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item) in activeUsers" v-bind:key="item.Id">
                                            <td>
                                                <b>Email: </b>{{item.Email}} <br />
                                                <template v-if="item.LastName || item.firstName"><b>Name: </b>{{item.LastName}}, {{item.FirstName}} <br/></template>
                                                <template v-if="item.SpouseName"><b>Spouse Name: </b>{{item.SpouseName}}</template>
                                            </td>
                                            <td>
                                                <input type="checkbox" value="ITSAdmin" v-model="item.Roles" @change="(e) => { changeRoles(item, e.target.value, e.target.checked); }"> Site Administrator
                                            </td>
                                            <td>
                                                <textarea class="form-control" v-model="item.Comment" @change="updateComment(item)"/>
                                            </td>
                                            <td>
                                                <button type="button" class="btn btn-sm vesta-gray-btn" style="margin-right: 1em;" @click="setActiveUserPending(item.Id);">Set Inactive</button>
                                                <button type="button" class="btn btn-sm vesta-gray-btn" data-toggle="modal" data-target="#deleteUserModal" @click="setDeleteUserId(item.Id);">Delete</button><br/>
                                                <span class="badge badge-pill badge-success" v-if="item.ApprovedOn">Approved on {{new Date(item.ApprovedOn).toLocaleDateString('en-AU')}}</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <pagination
                                    v-bind:total-pages="activeTotalPages"
                                    v-bind:total="activeTotalItems"
                                    :per-page="10"
                                    v-bind:current-page="activeCurrentPage"
                                    @pagechanged="onActivePageChange"
                                 />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div id="deleteUserModal" class="modal fade" role="dialog">
        <div class="modal-dialog">
            <!-- Modal content-->
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Are you sure you want to delete this user?</h4>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn vesta-gray-btn" data-dismiss="modal">Cancel</button>
                    <button type="button" class="btn vesta-gray-btn" data-dismiss="modal" @click="deleteUser();">Delete</button>
                </div>
            </div>
        </div>
    </div>
</div>

</template>

<style>
.has-error {
    border-color: red;
}
</style>

<script>
/* eslint-disable */
import axios from 'axios'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import Pagination from '../../components/Pagination.vue'

export default {
    data() {
        return {
            searchText: '',
            serverErrors: [],
            // pending variables
            pendingTotalPages: 0,
            pendingTotalItems: 0,
            pendingCurrentPage: 1,
            pendingUsers: [],

            // active variables
            activeTotalPages: 0,
            activeTotalItems: 0,
            activeCurrentPage: 1,
            activeUsers: [],

            pendingUserId: null,
            isLoading: false,
            deleteUserId: null
        }
    },
    created: function () {
        this.pendingCurrentPage = 1;
        this.activeCurrentPage = 1;
        const vm = this;

        this.fetchPending(this.pendingCurrentPage);
        this.fetchActive(this.activeCurrentPage);
    },
    components: {
      Loading,
      Pagination
    },
    methods: {
        onPendingPageChange: function(page) {
            this.pendingCurrentPage = page;
            this.fetchPending(page);
        },
        onActivePageChange: function(page) {
            this.activeCurrentPage = page;
            this.fetchActive(page);
        },
        setDeleteUserId: function(id) {
            this.deleteUserId = id;
        },
        fetchPending: function (page) {
            const vm = this;
            axios.get('/api/users/pending?page=' + page).then(function (response) {
                    if (response.data.status_code === 200) {
                        if (response.data.results && response.data.results.length === 1) {
                            var results = response.data.results[0];

                            // no results for this page...
                            if (results.Results.length === 0 && vm.pendingCurrentPage > 1) {
                                vm.pendingCurrentPage = vm.pendingCurrentPage - 1;
                                vm.fetchPending(vm.pendingCurrentPage);
                            } else {
                                // update variables...
                                vm.pendingUsers = results.Results;
                                vm.pendingTotalPages = results.TotalPages;
                                vm.pendingTotalItems = results.TotalItems;
                            }
                        }
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        fetchActive: function (page) {
            const vm = this;
            vm.isLoading = true;
            axios.get('/api/users/active?page=' + page).then(function (response) {
                vm.isLoading = false;

                if (response.data.status_code === 200) {
                    if (response.data.results && response.data.results.length === 1) {
                        var results = response.data.results[0];

                        // no results for this page...
                        if (results.Results.length === 0 && vm.activeCurrentPage > 1) {
                            vm.activeCurrentPage = vm.activeCurrentPage - 1;
                            vm.fetchActive(vm.activeCurrentPage);
                        } else {
                            //Convert to view model
                            (results.Results || []).forEach ((user) => {
                                user.Roles = user.Roles || [];
                            });

                            // update variables...
                            vm.activeUsers = results.Results;
                            vm.activeTotalPages = results.TotalPages;
                            vm.activeTotalItems = results.TotalItems;
                        }
                    }
                }
            })
            .catch(function (error) {
                console.log(error);
            });
        },
        pageClick: function (mode, pageNum) {
            if (mode === 'pending') {
                this.fetchPending(pageNum);
                this.pendingCurrentPage = pageNum;
            } else if (mode === 'active') {
                this.fetchActive(pageNum);
                this.activeCurrentPage = pageNum;
            } 
        },
        previousClick: function (mode) {
            if (mode === 'pending') {
                this.pendingCurrentPage = this.pendingCurrentPage - 1;
                this.fetchPending(this.pendingCurrentPage);
            } else if (mode === 'active') {
                this.activeCurrentPage = this.activeCurrentPage - 1;
                this.fetchActive(this.activeCurrentPage);
            } 
        },
        nextClick: function (mode) {
            if (mode === 'pending') {
                this.pendingCurrentPage = this.pendingCurrentPage + 1;
                this.fetchPending(this.pendingCurrentPage);
            } else if (mode === 'active') {
                this.activeCurrentPage = this.activeCurrentPage + 1;
                this.fetchActive(this.activeCurrentPage);
            }
        },
        setActiveUserPending: function (id) {
            const vm = this;
            this.isLoading = true;
            axios.post('/api/users/pending/setInactive', {
                UserId: id
            }).then(function (response) {
                vm.isLoading = false;
                if (response.data.status_code === 200) {
                    vm.fetchPending(vm.pendingCurrentPage);
                    vm.fetchActive(vm.activeCurrentPage);
                } else {
                    if (response.data.errors.length > 0) {
                        response.data.errors.forEach(item => {
                            self.serverErrors.push(item.error);
                        });
                    } else {
                        self.serverErrors.push('An error occurred setting this user active.');
                    }
                }
            })
            .catch(function (error) {
                console.log(error);
                vm.isLoading = false;
            });
        },
        cancelSearch: function() {
            this.searchText = '';
            this.searchUser();
        },
        searchUser: function() {
            const vm = this;
            
            if (vm.searchText == '') {
                vm.fetchActive(1);
                return;
            }

            vm.Loading = true;
            axios.get('/api/users/search?searchText=' + vm.searchText).then(response => {
                vm.Loading = false;
                if (response.data.status_code === 200) {
                    if (response.data.results && response.data.results.length === 1) {
                        var results = response.data.results[0];

                        (results.Results || []).forEach ((user) => {
                            user.Roles = user.Roles || [];
                        });

                        vm.activeCurrentPage = 1;
                        vm.activeUsers = results.Results;
                        vm.activeTotalPages = results.TotalPages;
                        vm.activeTotalItems = results.TotalItems;
                    }
                }
            })
            .catch(error => { 
                console.log(error); 
                vm.Loading = false; 
            });
        },
        changeRoles: function(item, role, value) {
            const vm = this;
            this.isLoading = true;
            axios.post('/api/users/setroles', {
                UserId: item.Id,
                Role: role,
                DeleteRole: !value
            }).then(function (response) {
                vm.isLoading = false;
                if (response.data.status_code !== 200) {
                    if (response.data.errors.length > 0) {
                        response.data.errors.forEach(item => {
                            vm.serverErrors.push(item.error);
                        });
                    } else {
                        vm.serverErrors.push('An error occurred setting this users role.');
                    }
                }
            })
            .catch(function (error) {
                console.log(error);
                vm.isLoading = false;
            });
        },
        updateComment: function(item) {
            console.log(item.Comment);
            const vm = this;
            this.isLoading = true;
            axios.post('/api/users/comment', {
                UserId: item.Id,
                Comment: item.Comment
            }).then(function (response) {
                vm.isLoading = false;
                if (response.data.status_code !== 200) {
                    if (response.data.errors.length > 0) {
                        response.data.errors.forEach(item => {
                            vm.serverErrors.push(item.error);
                        });
                    } else {
                        vm.serverErrors.push('An error occurred setting this users role.');
                    }
                }
            })
            .catch(function (error) {
                console.log(error);
                vm.isLoading = false;
            });
        },
        deleteUser: function() {
            const vm = this;
            this.isLoading = true;
            axios.post('/api/users/delete',{
                UserId: this.deleteUserId
            }).then(function (response) {
                vm.isLoading = false;
                if (response.data.status_code === 200) {
                    vm.fetchPending(vm.pendingCurrentPage);
                    vm.fetchActive(vm.activeCurrentPage);
                } else {
                    if (response.data.errors.length > 0) {
                        response.data.errors.forEach(item => {
                            self.serverErrors.push(item.error);
                        });
                    } else {
                        self.serverErrors.push('An error occurred setting this user active.');
                    }
                }
            })
            .catch(function (error) {
                console.log(error);
                vm.isLoading = false;
            });
        },
        setPendingUserActive: function (id) {
            const vm = this;
            this.isLoading = true;
            axios.post('/api/users/pending/setActive', {
                UserId: id,
            }).then(function (response) {
                vm.isLoading = false;
                if (response.data.status_code === 200) {
                    vm.fetchPending(vm.pendingCurrentPage);
                    vm.fetchActive(vm.activeCurrentPage);
                } else {
                    if (response.data.errors.length > 0) {
                        response.data.errors.forEach(item => {
                            self.serverErrors.push(item.error);
                        });
                    } else {
                        self.serverErrors.push('An error occurred setting this user active.');
                    }
                }
            }).catch(function (error) {
                console.log(error);
                vm.isLoading = false;
            });
        },

        addToVestaUsers: function() {
            const vm = this;
            this.isLoading = true;
            self.serverErrors = [];
            axios.post('/api/users/addvestauser', {
                UserId: vm.pendingUserId,
            }).then(function (response) {
                vm.isLoading = false;
                if (response.data.status_code === 200) {
                    vm.fetchPending(vm.pendingCurrentPage);
                    vm.fetchActive(vm.activeCurrentPage);
                } else {
                    if (response.data.errors.length > 0) {
                        response.data.errors.forEach(item => {
                            self.serverErrors.push(item.error);
                        });
                    } else {
                        self.serverErrors.push('An error occurred setting this user active.');
                    }
                }
            })
            .catch(function (error) {
                console.log(error);
                vm.isLoading = false;
            });
        }
    }
}
</script>
